<div
  class="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-lg transition-shadow duration-300 border border-gray-100"
>
  <div class="hidden lg:block">
    <div class="relative w-full h-32 mb-4">
      <img
        [src]="companyBanner(job)"
        alt="Banner de la empresa"
        class="w-full h-full object-cover rounded-t-lg"
      />
      <div class="absolute inset-0 opacity-50 bg-black"></div>
      <div
        class="absolute -bottom-8 left-1/2 transform rounded -translate-x-1/2 flex justify-center items-center"
      >
        <img
          [src]="companyImage(job)"
          alt="Logo"
          class="w-32 h-32 object-cover rounded-full shadow-lg border-4 border-white"
        />
      </div>
    </div>

    <div class="px-5 pt-12 pb-5">
      <div class="flex items-start justify-between gap-4 mb-3">
        <h3 class="text-xl font-semibold truncate flex-grow min-w-0 max-w-full">
          {{ job.title }}
        </h3>

        <div class="flex items-center gap-3 flex-shrink-0">
          @if (job.publicationStatus === 'Finalizado') {
          <span
            class="bg-red-100 text-red-600 text-xs font-semibold px-3 py-1 rounded-full shadow-sm whitespace-nowrap"
          >
            Oferta de empleo finalizada
          </span>
          } @if (ShowSalary(job)) {
          <div
            class="text-sm text-black font-bold text-right whitespace-nowrap"
          >
            {{ job.salary | solesCurrency }}
          </div>
          }
          <button
            [routerLink]="'job/' + job.idJobOffer"
            class="border border-gray-400 text-gray-700 px-3 py-2 rounded hover:border-primary hover:text-primary cursor-pointer whitespace-nowrap"
          >
            Detalles
          </button>
        </div>
      </div>

      <div class="flex justify-between items-center mb-4">
        <div
          class="text-sm text-gray-700 truncate min-w-0 max-w-[60%] lg:max-w-none"
        >
          <p>
            <span class="text-primary text-base font-medium truncate">
              {{ job.companyName }}
            </span>
          </p>
        </div>

        <p class="text-gray-500 text-sm flex-shrink-0 whitespace-nowrap">
          {{ job.publicationDate | timeAgo }} ·
          {{ job.visitsNumber | shortNumber }} visitas
        </p>
      </div>

      <div
        class="grid grid-cols-4 gap-4 text-center text-gray-600 pt-5 border-t border-gray-100"
      >
        <div>
          <p class="font-medium text-sm">Área</p>
          <p class="text-sm line-clamp-3">{{ job.area }}</p>
        </div>

        <div>
          <p class="font-medium text-sm">Modalidad</p>
          <p class="text-sm line-clamp-3">{{ job.modality }}</p>
        </div>

        <div>
          <p class="font-medium text-sm">Ubicación</p>
          <p class="text-sm line-clamp-3">{{ job.province }}</p>
        </div>

        <div>
          <p class="font-medium text-sm">Experiencia</p>
          @if(job.minimumExperience>0){
          <p class="text-sm line-clamp-3">{{ job.minimumExperience }}</p>
          } @else {
          <p class="text-sm line-clamp-3">Sin experiencia</p>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="p-4 lg:hidden">
  <div class="flex flex-col gap-3"> 

    <div class="flex items-start justify-between gap-3"> 
      
      <div
        class="shrink-0 w-12 h-12 rounded-lg overflow-hidden border border-gray-200"
      >
        <img
          [src]="companyImage(job)"
          alt="Logo de la empresa"
          class="w-full h-full object-cover"
        />
      </div>
      
      <div class="grow min-w-0 max-w-full">
        <h3 class="text-base md:text-xl font-semibold text-gray-900 truncate">
          {{ job.title }}
        </h3>
        <div class="flex items-center gap-2 text-sm text-gray-600 truncate">
          <p class="font-medium text-primary truncate">
            {{ job.companyName }}
          </p>
          <span class="text-xs text-gray-400">•</span>
          <p class="truncate">{{ job.province }}</p>
        </div>
      </div>
      
      @if (ShowSalary(job)) {
      <div class="shrink-0 text-right md:hidden"> 
        <p class="text-base font-bold text-black whitespace-nowrap">
          {{ job.salary | solesCurrency }}
        </p>
      </div>
      }
    </div>

    <div
      class="flex flex-wrap items-center gap-2 border-t pt-3 mt-1 border-gray-100"
    >
      @if (job.publicationStatus === 'Finalizado') {
      <span
        class="bg-red-100 text-red-600 text-xs font-semibold px-2 py-0.5 rounded-full whitespace-nowrap order-first"
      >
        Finalizada
      </span>
      } 
      
      @if (ShowSalary(job)) {
      <div class="hidden md:inline-flex shrink-0 mr-4 items-center"> 
        <p class="text-base font-medium text-black whitespace-nowrap">
          {{ job.salary | solesCurrency }}
        </p>
      </div>
      }
      
      <span
        class="text-xs font-medium bg-indigo-50 text-indigo-700 px-2 py-0.5 rounded-full truncate max-w-[8rem]"
      >
        {{ job.area }}
      </span>
      <span
        class="text-xs font-medium bg-green-50 text-green-700 px-2 py-0.5 rounded-full truncate max-w-[8rem]"
      >
        {{ job.modality }}
      </span>
      <span
        class="text-xs font-medium bg-gray-100 text-gray-700 px-2 py-0.5 rounded-full truncate max-w-[8rem]"
      >
        @if(job.minimumExperience>0){ {{ job.minimumExperience }} años } @else
        { Sin experiencia }
      </span>
    </div>

    <div class="flex justify-between items-center"> 
      <div
        class="shrink-0 text-xs text-gray-500 flex items-center gap-2"
      >
        <span>{{ job.publicationDate | timeAgo }}</span>
        <span class="text-xs text-gray-400">•</span>
        <span>{{ job.visitsNumber | shortNumber }} vistas</span>
      </div>
      <button
        [routerLink]="'job/' + job.idJobOffer"
        class="text-sm font-medium text-primary hover:text-indigo-700 transition-colors whitespace-nowrap"
      >
        Ver detalles
      </button>
    </div>
  </div>
</div>
</div>
